import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import DatePicker from 'react-datepicker';

const Calender = ({func, cDate}) => {
  // const [startDate, setStartDate] = useState(new Date());
  // const handleChange = (date) => {
  //   setStartDate(date);
  // };
  return (
    <Card className='general-cal'>
      <CardBody className='cal-date-widget'>
        <div className='cal-datepicker'>
          <div className='datepicker-here float-sm-end'>
            <DatePicker selected={cDate} onChange={func} inline />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Calender;
